import engagementNotifications from "../services/engagement.notifications";
import notification from "../services/notification";

export default {
    namespaced: true,

    state: {
        loading: false,
        errors: null,
        channelList: [],
        selectedChannel: null,
        notificationCategories: [],
        selectedNotificationCategory: null,
        notificationTemplates: []
    },
    mutations: {
        loading(state, value) {
            state.loading = value;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        setErrors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        setChannelList(state, channelList) {
            state.channelList = channelList;
            state.loading = false;
        },
        setSelectedChannel(state, selectedChannel) {
            state.selectedChannel = selectedChannel;
            state.loading = false;
        },
        setNotificationCategories(state, notificationCategories) {
            state.notificationCategories = notificationCategories;
            state.loading = false;
        },
        setSelectedNotificationCategory(state, selectedNotificationCategory) {
            state.selectedNotificationCategory = selectedNotificationCategory;
            state.loading = false;
        },
        setNotificationTemplates(state, notificationTemplates) {
            state.notificationTemplates = notificationTemplates;
            state.loading = false;
        }
    },
    actions: {
        async channelToggleUpdate({ commit }, param) {
            commit("loading", true);
            try {
                await engagementNotifications.channelToggleUpdate(param);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                notification.warning(errors);
                commit("loading", false);
            }
        },
        async getChannelList({ commit }) {
            commit("loading", true);
            try {
                let response = await engagementNotifications.getChannelList();
                commit("setChannelList", response.data);
                commit("setSelectedChannel", response.data[0]); // On Create, Set Selected Channel to the First Channel From the Response
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async setSelectedChannel({ commit }, channel) {
            commit("loading", true);
            try {
                commit("setSelectedChannel", channel);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getNotificationCategories({ commit }) {
            commit("loading", true);
            try {
                let response = await engagementNotifications.getNotificationCategories();

                commit("setNotificationCategories", response.data);
                commit("setSelectedNotificationCategory", response.data[0]); // On Create, Set Selected Notification Category to the First Notification Category From the Response
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getNotificationTemplates({ commit }, param) {
            commit("loading", true);
            try {
                let response = await engagementNotifications
                    .getNotificationTemplates(param)
                    .then(function(response) {
                        for (
                            let firstIndex = 0;
                            firstIndex < response.data.types.length;
                            firstIndex++
                        ) {
                            response.data.types[firstIndex].customize[
                                "original_custom_value"
                            ] =
                                response.data.types[
                                    firstIndex
                                ].customize.custom_value;

                            for (
                                let secondIndex = 0;
                                secondIndex <
                                response.data.types[firstIndex].standard
                                    .allowed_variables.length;
                                secondIndex++
                            ) {
                                const variable =
                                    response.data.types[firstIndex].standard
                                        .allowed_variables[secondIndex];

                                if (secondIndex == 0) {
                                    response.data.types[firstIndex].customize[
                                        "custom_value_for_editing"
                                    ] = response.data.types[
                                        firstIndex
                                    ].customize.custom_value.replaceAll(
                                        variable,
                                        "<span style='color: rgb(81, 130, 255);'>&lt;" +
                                            variable
                                                .replace("<", "")
                                                .replace(">", "") +
                                            "&gt;</span>"
                                    );

                                    response.data.types[firstIndex].customize[
                                        "original_custom_value_for_editing"
                                    ] = response.data.types[
                                        firstIndex
                                    ].customize.custom_value.replaceAll(
                                        variable,
                                        "<span style='color: rgb(81, 130, 255);'>&lt;" +
                                            variable
                                                .replace("<", "")
                                                .replace(">", "") +
                                            "&gt;</span>"
                                    );
                                } else {
                                    response.data.types[firstIndex].customize[
                                        "custom_value_for_editing"
                                    ] = response.data.types[
                                        firstIndex
                                    ].customize.custom_value_for_editing.replaceAll(
                                        variable,
                                        "<span style='color: rgb(81, 130, 255);'>&lt;" +
                                            variable
                                                .replace("<", "")
                                                .replace(">", "") +
                                            "&gt;</span>"
                                    );

                                    response.data.types[firstIndex].customize[
                                        "original_custom_value_for_editing"
                                    ] = response.data.types[
                                        firstIndex
                                    ].customize.original_custom_value_for_editing.replaceAll(
                                        variable,
                                        "<span style='color: rgb(81, 130, 255);'>&lt;" +
                                            variable
                                                .replace("<", "")
                                                .replace(">", "") +
                                            "&gt;</span>"
                                    );
                                }

                                // response.data.types[firstIndex].customize[
                                //     "original_custom_value_for_editing"
                                // ] = response.data.types[
                                //     firstIndex
                                // ].customize.custom_value.replace(
                                //     variable,
                                //     "<span style='color: color: rgb(81, 130, 255);'>&lt;" +
                                //         variable
                                //             .replace("<", "")
                                //             .replace(">", "") +
                                //         "&gt;</span>"
                                // );
                            }

                            response.data.types[firstIndex].customize[
                                "custom_value_for_editing"
                            ] =
                                "<p>" +
                                response.data.types[firstIndex].customize
                                    .custom_value_for_editing +
                                "</p>";

                            response.data.types[firstIndex].customize[
                                "original_custom_value_for_editing"
                            ] =
                                "<p>" +
                                response.data.types[firstIndex].customize
                                    .original_custom_value_for_editing +
                                "</p>";
                        }

                        return response;
                    });
                commit("setNotificationTemplates", response.data);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async saveNotificationTemplate({ commit }, param) {
            commit("loading", true);
            try {
                await engagementNotifications.saveNotificationTemplate(param);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        }
    }
};
